import useMobileDetector from '@shared/hooks/useMobileDetector';
import { selectIsDemoUser } from '@shared/store/auth/auth.selectors';
import { MdcBox } from 'ids-wc/dist/react/components';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';
import styles from './DashboardLayout.module.css';
import { DemoUserHeader } from './DemoUserHeader/DemoUserHeader.component.tsx';
import Sidebar from './Sidebar/Sidebar.component.tsx';
import { Tabbar } from './Tabbar/Tabbar.component.tsx';

export default function DashboardLayout() {
  const isMobile = useMobileDetector();
  const isDemoUser = useSelector(selectIsDemoUser);

  return (
    <Fragment>
      <MdcBox>
        <MdcBox wrap="nowrap" display="flex">
          {!isMobile && <Sidebar />}
          <MdcBox
            className={`${isMobile ? 'px-2' : 'px-6'} ${styles['main-section']}`}
            style={{
              paddingBlockStart: isMobile ? 'calc(1rem + var(--safe-area-inset-top))' : 0,
              paddingBlockEnd: isMobile ? 'calc(60px + max(var(--safe-area-inset-bottom), 20px) + 1rem)' : '1rem'
            }}
          >
            <section className={styles['outlet-container']}>
              {isDemoUser && <DemoUserHeader />}
              <Outlet />
            </section>
          </MdcBox>
        </MdcBox>
      </MdcBox>
      {isMobile ? <Tabbar /> : null}
    </Fragment>
  );
}
